"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var proxy_1 = require("../proxy");
var logger_1 = require("./logger");
var watch_1 = require("./watch");
function isSSR() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}
exports.isSSR = isSSR;
var FakeStorage = {
    loadList: function () { return []; },
    saveList: function () { return null; },
};
var instance = false;
function createInstance() {
    var logger = new logger_1.SSRLogger();
    var watcher = new watch_1.SSRChannelWatch(FakeStorage);
    var watch = watcher.watch, unwatch = watcher.unwatch, watching = watcher.watching;
    var proxy = new proxy_1.Proxy(logger, watching);
    var error = proxy.error, warn = proxy.warn, info = proxy.info, log = proxy.log, trace = proxy.trace, createLogger = proxy.createLogger, list = proxy.list, alert = proxy.alert, alertOnError = proxy.alertOnError;
    return {
        watch: watch,
        unwatch: unwatch,
        watching: watching,
        error: error,
        warn: warn,
        info: info,
        log: log,
        trace: trace,
        createLogger: createLogger,
        list: list,
        getServerSideLogs: logger.getServerSideLogs,
        alert: alert,
        alertOnError: alertOnError,
    };
}
function getServerInstance() {
    if (!instance) {
        instance = createInstance();
    }
    return instance;
}
exports.getServerInstance = getServerInstance;
//# sourceMappingURL=index.js.map